(() => {
  const initializeGallery = (root) => {
    if (root.dataset.galleryReady === 'true') return;

    const image = root.querySelector('[data-vella-gallery-image]');
    const thumbnails = Array.from(root.querySelectorAll('[data-vella-gallery-thumb]'));
    const dots = Array.from(root.querySelectorAll('[data-vella-gallery-dot]'));
    const previous = root.querySelector('[data-vella-gallery-previous]');
    const next = root.querySelector('[data-vella-gallery-next]');
    if (!image || thumbnails.length === 0) return;

    let activeIndex = 0;
    let touchStartX = null;

    const show = (index) => {
      const normalizedIndex = (index + thumbnails.length) % thumbnails.length;
      const thumbnail = thumbnails[normalizedIndex];
      image.classList.add('is-changing');

      window.setTimeout(() => {
        image.src = thumbnail.dataset.src;
        image.alt = thumbnail.dataset.alt || '';
        activeIndex = normalizedIndex;
        thumbnails.forEach((item, itemIndex) => {
          const isActive = itemIndex === activeIndex;
          item.classList.toggle('is-active', isActive);
          item.setAttribute('aria-current', isActive ? 'true' : 'false');
        });
        dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === activeIndex));
        image.classList.remove('is-changing');
      }, 110);
    };

    thumbnails.forEach((thumbnail, index) => thumbnail.addEventListener('click', () => show(index)));
    dots.forEach((dot, index) => dot.addEventListener('click', () => show(index)));
    previous?.addEventListener('click', () => show(activeIndex - 1));
    next?.addEventListener('click', () => show(activeIndex + 1));

    root.addEventListener('touchstart', (event) => {
      touchStartX = event.changedTouches[0]?.clientX ?? null;
    }, { passive: true });
    root.addEventListener('touchend', (event) => {
      if (touchStartX === null) return;
      const distance = (event.changedTouches[0]?.clientX ?? touchStartX) - touchStartX;
      if (Math.abs(distance) > 45) show(activeIndex + (distance < 0 ? 1 : -1));
      touchStartX = null;
    }, { passive: true });

    root.dataset.galleryReady = 'true';
  };

  const initializeAll = (scope = document) => {
    scope.querySelectorAll('[data-vella-gallery]').forEach(initializeGallery);
  };

  document.addEventListener('DOMContentLoaded', () => initializeAll());
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
